// src/components/ProcessFace.js
import React, { useEffect, useRef } from 'react';
import incode from "../services/incode";

const ProcessFace = ({ session, onSuccess, onError, userExists,ok }) => {
  const containerRef = useRef();



  useEffect(() => {
    incode.renderLogin(containerRef.current, {
      onSuccess,           
      onError,
      stopAtAccessDenied: true,
      stopAtError: true,
      token: session,           
      userExists
  });

  }, [onSuccess, onError, session, userExists]);

  return <div ref={containerRef}></div>;
};

export default ProcessFace;
